import React, { } from "react";
import { useSelector } from "react-redux";
import { get_sample_types } from "../../../redux/po_backlog/backlog.selector";
import { Container } from "@mui/material";
import ExpiryChartRenderer from "./ExpiryChartRenderer";


const ExpiryBarChart = () => {
  const sample_types = useSelector(get_sample_types);
  return (
    <Container>
      {
        sample_types?.map(sample_type => <ExpiryChartRenderer sample_type={sample_type} key={`${sample_type}-chart rendered`} />)
      }
    </Container>
  );
};

export default ExpiryBarChart;
